import React from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { IconButton, Modal } from "components"
import classes from "./PrinterErrorModal.module.scss"

const PrinterErrorModal = props => {
  const {
    showErrorModal,
    setShowErrorModal,
    printerInterface
  } = props

  const [t] = useTranslation()

  return (
    <Modal

      className={classes["modal"]}
      show={showErrorModal}
      onHide={() => setShowErrorModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["close"]}>
          <IconButton
            icon={MdClose}
            size={18}
            onClick={() => setShowErrorModal(false)}
          />
        </div>
        {printerInterface === "usb"
          ? t("پرینتر_یافت_نشد_لطفا_از_اتصال_پرینتر_مطمئن_شوید_و_دوباره_تلاش_کنین")
          : printerInterface === "tcp"
            ? t("پرینتر_یافت_نشد_لطفا_از_ip_پرینتر_مطمئن_شوید_و_دوباره_تلاش_کنین")
            : t("پرینتر_یافت_نشد_لطفا_از_اتصال_بلوتوث_پرینتر_مطمئن_شوید_و_دوباره_تلاش_کنین")
        }
        <div className={classes["title"]}>

        </div>
      </div>
    </Modal>
  )
}



export default PrinterErrorModal